import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import {
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  scmAuthApiRef,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { catalogImportApiRef, CatalogImportClient } from './api';

/** Native RouteRef for the catalog import page in the new frontend system. */
export const customeCatalogImportRouteRef = createRouteRef();

const catalogImportApi = ApiBlueprint.make({
  name: 'catalog-import',
  params: define =>
    define(
      createApiFactory({
        api: catalogImportApiRef,
        deps: {
          configApi: configApiRef,
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          scmAuthApi: scmAuthApiRef,
          scmIntegrationsApi: scmIntegrationsApiRef,
          catalogApi: catalogApiRef,
        },
        factory: ({
          configApi,
          discoveryApi,
          fetchApi,
          scmAuthApi,
          scmIntegrationsApi,
          catalogApi,
        }) =>
          new CatalogImportClient({
            configApi,
            discoveryApi,
            fetchApi,
            scmAuthApi,
            scmIntegrationsApi,
            catalogApi,
          }),
      }),
    ),
});

const catalogImportPage = PageBlueprint.make({
  params: {
    path: '/catalog-import',
    noHeader: true,
    routeRef: customeCatalogImportRouteRef,
    loader: () =>
      import('./components/ImportPage/ImportPage').then(
        ({ ImportPage }) => <ImportPage />,
      ),
  },
});

export default createFrontendPlugin({
  pluginId: 'custome-catalog-import',
  extensions: [catalogImportApi, catalogImportPage],
});
